import { render, staticRenderFns } from "./EditProtocoloModal.vue?vue&type=template&id=73723039&scoped=true"
import script from "./EditProtocoloModal.vue?vue&type=script&lang=js"
export * from "./EditProtocoloModal.vue?vue&type=script&lang=js"
import style0 from "./EditProtocoloModal.vue?vue&type=style&index=0&id=73723039&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73723039",
  null
  
)

export default component.exports